export const apiPrefix = process.env.REACT_APP_API_PREFIX || '/api';
